import { ReactNode } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import { Spin, SpinProps } from 'antd';
import { observer } from 'mobx-react-lite';

import styles from './loading.module.css';

type LoadingProps = {
  active: boolean;
  children?: ReactNode | Array<ReactNode>;
} & SpinProps;

const Icon = (
  <LoadingOutlined style={{ fontSize: 24, background: 'purpule' }} spin />
);

export const Loading = observer(
  ({ active, children, wrapperClassName, ...props }: LoadingProps) => {
    return (
      <Spin
        wrapperClassName={`${styles.fullHeight} ${wrapperClassName}`}
        delay={0}
        indicator={Icon}
        spinning={active}
        {...props}
        style={{
          minHeight: 30,
          maxWidth: '100%',
          width: '100%',
          ...props.style,
        }}
      >
        {children}
      </Spin>
    );
  },
);
